var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"watermark",style:(("background-image: url(" + _vm.userId + "),url(" + _vm.userId + "),url(" + _vm.userId + ");")),attrs:{"id":"watermark"}})}
var staticRenderFns = []

export { render, staticRenderFns }